import { Maybe } from '@pylot-data/pylotschema'

export const stockValidationQuery = /* GraphQL */ `
    mutation getValidationStock($input: SkuInput!) {
        getValidationStock(input: $input) {
            available
            name
            sku
            stock
        }
    }
`
export interface StockItem {
    sku: string | Maybe<string> | undefined
    quantity: string
}

export interface StockValidationInput {
    input: { items: StockItem[] }
}

export interface ValidationStockResult {
    available: string
    name: string
    sku: string
    stock: string
}

export interface StockValidationOutput {
    getValidationStock: ValidationStockResult[]
}
